import {Component, EventEmitter, Input, NgZone, Output} from '@angular/core';
import {NavItem} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pt-navbar-menu-item',
  template: `
    <div ngbDropdown #myDrop='ngbDropdown' autoClose='true' display="dynamic">
      <button ngbDropdownToggle
              id='dropdownBasic1'
              [ngClass]='toggleClass'
              class='btn btn-sm btn-outline-link d-flex align-items-center'
              [disabled]='!isEnabled || (item?.disabled | async)'
              (click)='$event.stopPropagation(); setOverMenuToggle(myDrop);'>
        <pt-icon class="hstack"
                 *ngIf='item.icon'
                 [key]='item.icon.key'
                 [size]="item.icon.size"
                 [iconType]="item.icon.type"
        ></pt-icon>
        <span class="ms-1">{{ item.label | async }}</span>
      </button>

      <div ngbDropdownMenu class='dropdown-menu' (click)='$event.stopPropagation();'>
        <ng-container *ngFor='let sub of item.children'>
          <pt-navbar-item ngbDropdownItem class='m-0 p-0' [item]='sub'
                          (clickAction)='clickAction.emit($event)'>
          </pt-navbar-item>
        </ng-container>
      </div>
    </div>
  `
})
export class NavbarMenuItemComponent {

  @Input() item: NavItem;
  @Input() placement: string;
  @Output() clickAction = new EventEmitter<NavItem>();

  toggleClass: string[];
  isEnabled: boolean;

  private overMenuToogle = false;
  private overMenu = false;

  constructor(private permissionService: NgxPermissionsService, private ngZone: NgZone) {
  }

  ngOnInit(): void {
    if (this.item) {
      this.toggleClass = ['btn'];
      if (this.item.classCss) {
        this.toggleClass.push(...this.item.classCss);
      }
      this.permissionService.hasPermission(this.item.permissEnabled).then((enabled) => {
        this.isEnabled = enabled;
      });
    }
  }

  setOverMenuToggle(myDrop: NgbDropdown) {
    this.overMenuToogle = myDrop.isOpen();
    if (this.isOpenMenu()) {
      myDrop.open();
    } else {
      myDrop.close();
    }
  }

  isOpenMenu(): boolean {
    return this.overMenu || this.overMenuToogle;
  }
}
